import { render } from "./Race8.vue?vue&type=template&id=6206610b&scoped=true"
import script from "./Race8.vue?vue&type=script&lang=js"
export * from "./Race8.vue?vue&type=script&lang=js"

import "./Race8.vue?vue&type=style&index=0&id=6206610b&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6206610b"]])

export default __exports__